import React from 'react';

import { IntlFormatters } from 'react-intl';

import { INutritionInfo, ISanityImage } from '@rbi-ctg/menu';

import { AllergenGroup } from '../types';
import {
  parsePerMassItemNutritionInfo,
  parsePerServingItemNutritionInfo,
  sortNutritionInfo,
} from '../utils';
import { Nutrition } from '../v2/nutrition';

import { StyledAllergens } from './allergens';
import { ContentWrapper } from './content-wrapper';
import { ItemName } from './item-name';
import { NutritionTableRow } from './nutrition-table-row';
import { Picture } from './picture';
import { TableHeader } from './table-header';

interface IItemNutritionProps {
  allergenGroups: AllergenGroup[] | undefined;
  itemImage: ISanityImage;
  itemName: string;
  nutritionInfo: INutritionInfo;
  enableEUNutritionDisplay: boolean;
  enableFeatureNutritionIntegration: boolean;
  enableStaticMenuAllergens: boolean;
  formatMessage: IntlFormatters['formatMessage'];
}
export const ItemNutrition: React.FC<IItemNutritionProps> = ({
  allergenGroups,
  itemImage,
  itemName,
  nutritionInfo,
  enableEUNutritionDisplay,
  enableFeatureNutritionIntegration,
  enableStaticMenuAllergens,
  formatMessage,
}) => {
  const nutritionIds = sortNutritionInfo(enableEUNutritionDisplay);
  const perServing = parsePerServingItemNutritionInfo({
    nutritionIds,
    nutritionInfo,
    enableEUNutritionDisplay,
    formatMessage,
  });
  const perMass = parsePerMassItemNutritionInfo({
    nutritionIds,
    nutritionInfo,
    enableEUNutritionDisplay,
    formatMessage,
  });

  return (
    <>
      <Picture image={itemImage} alt="" objectFitContain />
      <ContentWrapper>
        <ItemName>{itemName}</ItemName>
        {enableFeatureNutritionIntegration ? (
          <Nutrition nutritionInfo={nutritionInfo} />
        ) : (
          <>
            <TableHeader data-testid="per-serving-header">
              {formatMessage({ id: 'perServing' })}
            </TableHeader>
            {perServing.map(itemInfo => (
              <NutritionTableRow
                key={itemInfo.nutritionId}
                name={itemInfo.name}
                value={itemInfo.value}
                unit={itemInfo.unit}
                additionalUnit={itemInfo.additionalUnit}
              />
            ))}
            {!!(enableEUNutritionDisplay && perMass.length) && (
              <>
                <TableHeader data-testid="per-mass-header">
                  {formatMessage({ id: 'perOneHundredGOrMl' })}
                </TableHeader>
                {perMass.map(itemInfo => (
                  <NutritionTableRow
                    key={itemInfo.nutritionId}
                    name={itemInfo.name}
                    value={itemInfo.value}
                    unit={itemInfo.unit}
                    additionalUnit={itemInfo.additionalUnit}
                  />
                ))}
              </>
            )}
          </>
        )}
        {enableStaticMenuAllergens && !!allergenGroups?.length && (
          <>
            <TableHeader data-testid="allergens-header">
              {formatMessage({ id: 'allergenInformation' })}
            </TableHeader>
            <StyledAllergens allergenGroups={allergenGroups} />
          </>
        )}
      </ContentWrapper>
    </>
  );
};
